module.exports = __webpack_public_path__ + "static/media/e2386b0d-685b-4b1a-9e83-5332b5758dd0.09910e79.JPG";